<template>
  <section class="actions-cell is-inline-flex">
    <ActionCellEdit
      :table-id="tableId"
      :cell-data="cellData"
      :row-data="rowData"
      :column="column"
      :render-service="renderService"
      :data-service="dataService"
      :primary-key-field="primaryKeyField"
      :primary-name-field="primaryNameField"
    />
    <ActionCellDelete
      :table-id="tableId"
      :cell-data="cellData"
      :row-data="rowData"
      :column="column"
      :render-service="renderService"
      :data-service="dataService"
      :primary-key-field="primaryKeyField"
      :primary-name-field="primaryNameField"
    />
  </section>
</template>

<script>
import { ActionCellMixin } from '/@/modules/core/table/mixins/ActionCellMixin';
import ActionCellEdit from '/@/modules/core/table/components/ActionCellEdit.vue';
import ActionCellDelete from '/@/modules/core/table/components/ActionCellDelete.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'DefaultActionCell',
  mixins: [ActionCellMixin],
  components: {
    ActionCellEdit,
    ActionCellDelete
  }
};
</script>
